import { IConfig } from './presets/IConfig';

// eslint-disable @typescript-eslint/explicit-module-boundary-types
export class ConfigLoader {
	static instance: ConfigLoader;

	constructor(readonly config: IConfig, readonly preApiLoad?: void | (() => void)) {
		ConfigLoader.instance = this;
	}
}

export function createConfigLoader(config: IConfig, preApiLoad?: void | (() => void)): void {
	new ConfigLoader(config, preApiLoad);
}

export function getConfig<T = never>(): IConfig<T> {
	return ConfigLoader.instance.config;
}
